// Thin wrapper around the Google Analytics gtag() global.
// Silent no-op when gtag is not loaded (blocked, dev without network, etc.).
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", name, params);
  } catch (_) {
    /* swallow */
  }
}
